module.exports = __webpack_public_path__ + "img/logo-colour.c7ecc0d8.png";